/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import getMinValue from './userSettings/getMinValue';
import getMaxValue from './userSettings/getMaxValue';
import getDecimalPlaces from './userSettings/getDecimalPlaces';
import getValueSuffix from './userSettings/getValueSuffix';
import getLayout from './userSettings/getLayout';
import getColorStops from './userSettings/getColorStops';
import getPlotOffsets from './userSettings/getPlotOffsets';

export default function getUserSettings(formattingOptions :any) {

    let minValue = getMinValue(formattingOptions);
    let maxValue = getMaxValue(formattingOptions);

    if (maxValue < minValue) {
        // the maxValue should not be less than minValue, the UI should prevent this.
        // But, things may go wrong, and in this case I think it makes sense to reverse them
        [maxValue, minValue] = [minValue, maxValue];
    }

    const layout = getLayout(formattingOptions);
    const decimalPlaces = getDecimalPlaces(formattingOptions);
    const valueSuffix = getValueSuffix(formattingOptions);
    const colorStops = getColorStops(formattingOptions);
    const plotOffsets = getPlotOffsets(formattingOptions);

    return {
        layout,
        plotOffsets,
        minValue,
        maxValue,
        decimalPlaces,
        colorStops,
        valueSuffix
    }
};
